const appConfig = {
  apiPrefix: import.meta.env.VITE_APP_API_KEY,
  authenticatedEntryPath: '/home',
  unAuthenticatedEntryPath: '/home',
  imagePath: 'https://d2ykathgy3a8bl.cloudfront.net/assets/',
};

export default appConfig;
